import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import { NavButton } from "./styles";

export const renderPrevButton = ({ isDisabled = false }) => {
  return (
    <NavButton isDisabled={isDisabled}>
      <FiChevronLeft size={36} color="#fff" />
    </NavButton>
  );
};

export const renderNextButton = ({ isDisabled = false }) => {
  return (
    <NavButton isDisabled={isDisabled}>
      <FiChevronRight size={36} color="#fff" />
    </NavButton>
  );
};
